import React from 'react';
import PropTypes from 'prop-types';
import { getAllParams } from '../../service/utils';

const AccessibilityTabContent = ({ id, hidden, menu, children, ...params }) => {

    const additionalProps = {
        id: `${id}-panel`,
        role: menu ? "menu" : "tabpanel",
        'aria-labelledby': `${id}-tab`,
        hidden,
        ...getAllParams(params)
    }

    if (Array.isArray(children)) {
        // Wrap children array with a div and apply additional props
        return <div style={{ width: 'inherit', height: 'inherit' }} {...additionalProps}>{children}</div>;
    } else {
        // Ensure children is wrapped in a React element if it's a string
        const childElement = typeof children === 'string' ? <span>{children}</span> : children;
        // Clone the child element with the additional props
        return React.cloneElement(childElement, additionalProps);
    }

};

AccessibilityTabContent.propTypes = {
    id: PropTypes.string.isRequired,
    hidden: PropTypes.bool.isRequired,
    menu: PropTypes.bool,
    children: PropTypes.oneOfType([
        PropTypes.element,
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.string
    ]).isRequired,
};

export default AccessibilityTabContent;
